import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-transport-volume',
  templateUrl: './transport-volume.component.html',
  styleUrls: ['./transport-volume.component.scss'],
})
export class TransportVolumeComponent implements AfterViewInit {

  @ViewChild('gauge') gauge: ElementRef;
  @Input() set data(piles:any[]){
    this._piles = piles;
    this.prepareData();

  }
  @Input() road:string;
  private width:number=50;
  private height:number=50;
  private _piles:any[] = [];
  private svg:any;
  public percentage:number=0;
  constructor() { }
  ngAfterViewInit(): void {

    this.createSvg();
    this.drawChart();
  }



  createSvg(){
    const {width,height}=this;
    this.svg = d3.select(this.gauge.nativeElement).append("svg")
    .attr("width", this.width)
    .attr("height", this.height)
    .append("g")

    .attr("transform",
          `translate(${this.width/2},${this.height/2})`);
  }
  drawChart(){


  }

  prepareData(){

  }

}
